import React, { useEffect } from 'react'
import ReactDatePicker, {
  DatePickerProps as ReactDatePickerPops
} from 'react-date-picker/dist/entry.nostyle'
import { useField } from 'formik'
import classNames from 'classnames'

import { FaTimes } from 'react-icons/fa'
import { BsCalendar } from 'react-icons/bs'

import { FieldProps } from '../types'
import { FieldError } from '@components/form'

import styles from '../styles.module.scss'
import 'react-date-picker/dist/DatePicker.css'

type DatePickerProps = FieldProps & ReactDatePickerPops & { id: string }

export const DatePicker = ({
  name,
  label,
  id,
  error,
  withoutError = false,
  container: { className: containerClassName, ...container } = {},
  ...rest
}: DatePickerProps) => {
  const [field, meta] = useField<Date>(name)
  const handleOnChange = (date?: Date) => {
    field.onChange({
      target: {
        name,
        id,
        value: date
      }
    })
  }

  useEffect(() => {
    if (document?.body) {
      const element = document.querySelector<HTMLLabelElement>(
        `[for="${name}"]`
      )
      if (element) {
        const innerElement = element.nextElementSibling.firstElementChild
          .firstElementChild as HTMLDivElement
        if (innerElement) {
          element.addEventListener('click', () => {
            innerElement.click()
          })
        }
      }
    }
  }, [])

  return (
    <div
      id={id}
      className={classNames('flex flex-col', containerClassName)}
      {...container}
    >
      {label}
      <ReactDatePicker
        name={name}
        className={classNames(
          'date-picker',
          { error: meta.error && meta.touched },
          {
            'date-picker-empty': !field.value
          }
        )}
        onChange={date => !Array.isArray(date) && handleOnChange(date)}
        onCalendarClose={() =>
          field.onBlur({
            target: {
              name
            }
          })
        }
        value={field.value}
        clearIcon={<FaTimes className={styles.times} />}
        calendarIcon={<BsCalendar className={styles.times} />}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
